import { apiHolder, apis, util, conf, api, getIn18Text, } from 'api';
import cloneDeep from 'lodash/cloneDeep';
import { getValidEmail, StaticRootNodeKey } from '@web-common/utils/contact_util';
import { emailPattern } from '@web-common/utils/constant';
import { doGetCustomerContactByCustomerIds } from '@web-common/state/reducer/contactReducer';
const env = conf('stage');
export var SearchGroupKey;
(function (SearchGroupKey) {
    SearchGroupKey[SearchGroupKey["ALL"] = 0] = "ALL";
    SearchGroupKey[SearchGroupKey["CORP"] = 1] = "CORP";
    SearchGroupKey[SearchGroupKey["PERSON"] = 2] = "PERSON";
})(SearchGroupKey || (SearchGroupKey = {}));
export const CommonNull = null;
export const transTreeLeaf = (params) => {
    try {
        const { item, parentKey, isMailList } = params;
        const data = 'contact' in item ? transContactModel2ContactItem(item) : item;
        const { id, name, type, email } = data;
        const key = (parentKey ? parentKey + '_' : '') + (id || email);
        return {
            key,
            title: name || email,
            isLeaf: true,
            isOrg: false,
            data,
            nodeType: type,
            isMailList,
        };
    }
    catch (e) {
        contactUtilError('transTreeLeaf error', e);
        return CommonNull;
    }
};
export const transOrgItem2TreeNode = (data, isNodeLeaf = false) => {
    try {
        const { id, orgName, type } = data;
        let nodeType = 'enterprise';
        if (type === 2000) {
            nodeType = 'team';
        }
        else if (type === 2001) {
            nodeType = 'personal';
        }
        else if (type === 2002) {
            nodeType = 'customer';
        }
        else if (type === 2003) {
            nodeType = 'clue';
        }
        return {
            key: id,
            title: orgName,
            isLeaf: isNodeLeaf,
            isOrg: true,
            item: data,
            nodeType,
        };
    }
    catch (e) {
        contactUtilError('transOrgItem2TreeNode error', e);
        return CommonNull;
    }
};
export const createCustomerRoot = (params) => {
    const { children = [], hasMore = false, page = 0 } = params || {};
    return {
        key: StaticRootNodeKey.CUSTOMER,
        nodeType: 'customer',
        title: getIn18Text('myCustomer'),
        isLeaf: false,
        isOrg: true,
        children,
        hasMore,
        page,
    };
};
export const transServerCustomer2TreeNode = (data) => {
    return {
        key: data.id,
        title: data.orgName,
        isLeaf: false,
        isOrg: true,
        data,
        nodeType: 'customer',
        hasMore: true,
        page: 0,
    };
};
export const transTreeNode = (data, isNodeLeaf = false) => {
    try {
        const { id, orgName, type } = data;
        let nodeType = 'enterprise';
        if (type === 2000) {
            nodeType = 'team';
        }
        else if (type === 2001) {
            nodeType = 'personal';
        }
        else if (type === 2002) {
            nodeType = 'customer';
        }
        else if (type === 2003) {
            nodeType = 'clue';
        }
        return {
            key: id,
            title: orgName,
            isLeaf: isNodeLeaf,
            isOrg: true,
            data,
            nodeType,
        };
    }
    catch (e) {
        contactUtilError('transOrgItem2TreeNode error', e);
        return CommonNull;
    }
};
export const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
export const systemApi = api.getSystemApi();
export const getColor = (email) => contactApi.getColor(email);
export const getCharAvatar = (name) => {
    if (!name) {
        return name;
    }
    return name.charAt(0).toLocaleUpperCase();
};
export const fixContactLabel = (label) => (label === '|' ? '#' : label);
export const contact4ui = (list, pointLabel) => {
    const labels = new Set();
    if (!list) {
        return [];
    }
    return cloneDeep(list).map(e => {
        const r = e;
        r.contact.defaultEmail = e.contact.accountName;
        r.contact.charAvatar = getCharAvatar(e.contact.contactName);
        if (pointLabel) {
            if (!labels.has(r.contact.contactLabel)) {
                r.contact.labelPoint = !0;
                labels.add(r.contact.contactLabel);
            }
            else {
                r.contact.labelPoint = false;
            }
        }
        return r;
    });
};
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export const splitSearchHit = (hit, text) => {
    const searchText = escapeRegExp(hit.slice());
    const reg = new RegExp(searchText, 'i');
    const result = reg.exec(text.slice());
    if (!result) {
        return null;
    }
    const head = text.substring(0, result.index);
    const target = text.substring(result.index, result.index + hit.length);
    const tail = text.substring(result.index + hit.length);
    return {
        head,
        target,
        tail,
    };
};
export const getSearchContact = async (searchValue, isIM) => {
    if (!searchValue) {
        return null;
    }
    const t1 = Date.now();
    const data = await contactApi.doSearchContact(searchValue, isIM);
    const list = contact4ui(data);
    console.log(`Search ${searchValue} in ${Date.now() - t1}ms`, list);
    return {
        [SearchGroupKey.ALL]: list,
        [SearchGroupKey.CORP]: list.filter(e => e.contact.type === 'enterprise'),
        [SearchGroupKey.PERSON]: list.filter(e => e.contact.type === 'personal'),
    };
};
export function verifyEmail(email) {
    const emailReg = emailPattern;
    return emailReg.test(email);
}
export const creatExternalContentItem = (email, name) => {
    return {
        type: 'external',
        name: name || email,
        email,
    };
};
export const transTeamMember2ContactItem = (item) => {
    if (item.user) {
        return {
            id: item.user.contactId,
            type: 'enterprise',
            name: item.user.nick,
            email: item.user.email,
        };
    }
    else {
        return null;
    }
};
export const tarnsEntityContact2ContactItem = (item) => {
    try {
        const { id, type, avatar, contactName, position, accountType } = item;
        const email = contactApi.doGetModelDisplayEmail(item);
        return {
            id,
            type,
            avatar,
            name: contactName,
            email,
            position,
            accountType,
        };
    }
    catch (e) {
        contactUtilError('transContactModel2ContactItem error', e);
        return CommonNull;
    }
};
export const transEntityContactItem2ContactItem = (itemList) => {
    return itemList.map(item => {
        return {
            id: item.contactId,
            type: item.type,
            name: item.contactItemVal,
            email: item.contactItemVal,
        };
    });
};
export const buildOrgChildrenKey = (orgId, item) => {
    return orgId + '_' + ((item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.email));
};
export const transContactModel2ContactItem = (item) => {
    var _a, _b, _c;
    try {
        const { id, type, avatar, contactName, position, accountType } = (item === null || item === void 0 ? void 0 : item.contact) || {};
        const email = contactApi.doGetModelDisplayEmail(item);
        const emailList = new Set([email]);
        if ((_a = item === null || item === void 0 ? void 0 : item.contactInfo) === null || _a === void 0 ? void 0 : _a.length) {
            item.contactInfo.forEach(info => {
                if (info.contactItemType === 'EMAIL' && info.contactItemVal) {
                    emailList.add(info.contactItemVal);
                }
            });
        }
        return {
            id,
            type,
            avatar,
            name: contactName,
            email,
            emailList: [...emailList],
            emailCount: emailList.size,
            position,
            accountType,
            customerRole: (_b = item.customerOrgModel) === null || _b === void 0 ? void 0 : _b.role,
            createTime: (_c = item.customerOrgModel) === null || _c === void 0 ? void 0 : _c.createTime,
            reduxUpdateTime: item.reduxUpdateTime,
            _account: item._account,
        };
    }
    catch (e) {
        contactUtilError('transContactModel2ContactItem error', e);
        return CommonNull;
    }
};
export const transContactSearch2ContactItem = (item) => {
    try {
        const { id, type, avatar, contactName, position, accountName: _email, accountType, hitQueryEmail, remark } = item;
        const email = type === 'personal' && hitQueryEmail ? hitQueryEmail : _email;
        return {
            id,
            type,
            avatar,
            name: contactName,
            email,
            emailCount: item.emailCount,
            position,
            accountType,
            remark,
        };
    }
    catch (e) {
        contactUtilError('transContactSearch2ContactItem error', e);
        return CommonNull;
    }
};
export const transCustomerRole2EmailRole = (type, role) => {
    if (!role) {
        return role;
    }
    const lxType = ['enterprise', 'personal', 'external'];
    if (lxType.includes(type)) {
        return type;
    }
    const CustomerRoleObj = {
        manager: 'myCustomer',
        colleague: 'colleagueCustomer',
        openSea: 'openSeaCustomer',
    };
    return CustomerRoleObj[role];
};
export const transCustomerContactSearch2ContactItem = (item) => {
    try {
        const { id, type, contactName, accountName: email, customerRole, hitQuery, createTime } = item;
        return {
            id,
            type,
            name: contactName,
            email,
            customerRole,
            hitQuery,
            createTime,
        };
    }
    catch (e) {
        contactUtilError('transCustomerContactSearch2ContactItem error', e);
        return CommonNull;
    }
};
export const transOrgSearch2OrgItem = (item) => {
    try {
        const { id, type, orgRank, orgName, hitQuery, originId, memberNum } = item;
        let orgType = 'org';
        if (type === 2000) {
            orgType = 'team';
        }
        else if (type === 2001) {
            orgType = 'personalOrg';
        }
        return {
            id,
            orgType,
            type,
            orgRank,
            orgName,
            hitQuery,
            originId: originId || id,
            memberNum,
        };
    }
    catch (e) {
        contactUtilError('transOrgSearch2OrgItem error', e);
        return CommonNull;
    }
};
export const transCustomerOrgSearch2OrgItem = (item) => {
    try {
        const { id, type, orgRank, orgName, hitQuery, customerRole, originId } = item;
        let orgType = 'org';
        if (type === 2002) {
            orgType = 'customer';
        }
        else if (type === 2003) {
            orgType = 'clue';
        }
        return {
            id,
            orgType,
            type,
            orgRank,
            orgName,
            hitQuery,
            customerRole,
            originId,
        };
    }
    catch (e) {
        contactUtilError('transOrgSearch2OrgItem error', e);
        return CommonNull;
    }
};
export const transEntityOrg2OrgItem = (item) => {
    try {
        const { id, type, orgRank, orgName, originId } = item;
        let orgType = 'org';
        if (type === 2000) {
            orgType = 'team';
        }
        else if (type === 2001) {
            orgType = 'personalOrg';
        }
        else if (type === 2002) {
            orgType = 'customer';
        }
        else if (type === 2003) {
            orgType = 'clue';
        }
        return {
            id,
            type,
            orgRank,
            orgName,
            orgType,
            originId,
        };
    }
    catch (e) {
        contactUtilError('transOrgSearch2OrgItem error', e);
        return CommonNull;
    }
};
export const transCustomerSearchData = (data) => {
    const edmOptionsMap = {
        myCustomerContact: [],
        myCustomer: [],
        colleagueCustomerContact: [],
        colleagueCustomer: [],
    };
    const edmContactList = data.contact;
    edmContactList.forEach(item => {
        const contactItem = transCustomerContactSearch2ContactItem(item);
        const edmKey = contactItem.customerRole + 'Contact';
        const option = edmOptionsMap[edmKey] || [];
        option.push(contactItem);
        edmOptionsMap[edmKey] = option;
    });
    const edmOrgList = [...data.customer];
    edmOrgList.forEach(item => {
        const orgItem = transCustomerOrgSearch2OrgItem(item);
        const edmKey = orgItem.customerRole;
        const option = edmOptionsMap[edmKey] || [];
        option.push(orgItem);
        edmOptionsMap[edmKey] = option;
    });
    return edmOptionsMap;
};
export const transContactInfo2ContactItem = (item) => {
    const contactItems = [];
    if (item) {
        item.forEach(e => {
            contactItems.push({
                type: 'external',
                name: e.simpleInfo.extNickname || e.simpleInfo.extDesc || '',
                email: e.simpleInfo.extDesc || '',
            });
        });
    }
    return contactItems;
};
export const isEqualPersonalContact = (pre, cur) => {
    if ((cur === null || cur === void 0 ? void 0 : cur.contact) && (cur === null || cur === void 0 ? void 0 : cur.contactInfo) && (pre === null || pre === void 0 ? void 0 : pre.email) && (pre === null || pre === void 0 ? void 0 : pre.name)) {
        const { contactName, type, id } = cur.contact;
        if (type !== 'personal') {
            return false;
        }
        const { email, name, contactId } = pre;
        if (contactId && contactId === id) {
            return false;
        }
        if (name !== contactName) {
            return false;
        }
        const emailList = cur.contactInfo.filter(item => item.type === 'personal' && item.contactItemType === 'EMAIL');
        if (emailList.length !== 1) {
            return false;
        }
        const findEmail = emailList[0].contactItemVal;
        return findEmail === email.toLocaleLowerCase();
    }
    return false;
};
export const filterSameEmailAndHitQueryContact = (list) => {
    const contactEmailMap = {};
    const res = [];
    list.forEach(item => {
        var _a;
        const { contact, contactInfo, orgs } = item;
        if (contact.type === 'personal') {
            let hitQueryEmails = [];
            if ((_a = contact.hitQuery) === null || _a === void 0 ? void 0 : _a.length) {
                hitQueryEmails = contactInfo.filter(info => info.contactItemType === 'EMAIL');
            }
            else {
                hitQueryEmails = contactInfo.filter(info => { var _a; return ((_a = info.hitQuery) === null || _a === void 0 ? void 0 : _a.length) && info.contactItemType === 'EMAIL'; });
            }
            console.log('hitQueryEmails', hitQueryEmails);
            hitQueryEmails.forEach(info => {
                const email = info.contactItemVal;
                const obj = contactEmailMap[email];
                if (!obj) {
                    const newContact = Object.assign({}, contact);
                    newContact.hitQueryEmail = email;
                    const newItem = { contact: newContact, contactInfo, orgs };
                    res.push(newItem);
                    contactEmailMap[email] = {
                        index: res.length - 1,
                        item: newItem,
                    };
                }
            });
        }
        else if (contact.type === 'enterprise') {
            const email = contactApi.doGetModelDisplayEmail(item);
            const obj = contactEmailMap[email];
            const newContact = Object.assign({}, contact);
            newContact.hitQueryEmail = email;
            const newItem = { contact: newContact, contactInfo, orgs };
            if (obj) {
                res.splice(obj.index, 1, newItem);
                contactEmailMap[email] = {
                    index: obj.index,
                    item: newItem,
                };
            }
            else {
                res.push(newItem);
                contactEmailMap[email] = {
                    index: res.length - 1,
                    item: newItem,
                };
            }
        }
    });
    return res;
};
export const filterContactSameEmail = (list) => {
    const contactEmailMap = {};
    const res = [];
    list.forEach((item, index) => {
        const email = item.contact.accountName;
        const obj = contactEmailMap[email];
        if (obj) {
            const isEnterprise = item.contact.type === 'enterprise';
            if (isEnterprise) {
                res.splice(obj.index, 1, item);
                contactEmailMap[email] = {
                    index,
                    item,
                };
            }
        }
        else {
            contactEmailMap[email] = {
                index,
                item,
            };
            res.push(item);
        }
    });
    return res;
};
export const getTeams = async () => {
    const res = await contactApi.doGetOrgList({ typeList: [2000] });
    return res;
};
export const getTeamMembers = (idList, needGroup = true) => contactApi.doGetOrgContactListByTeamId({
    idList,
    needGroup,
    needContactModelData: true,
});
export const getTeamAndMemberByTeam = async (teamList) => {
    const idList = util.getKeyListByList(teamList, 'id');
    const teamMembers = (await contactApi.doGetOrgContactListByTeamId({
        idList,
        needContactModelData: true,
    }));
    const teamMemberMap = {};
    teamMembers.forEach(item => {
        const teamId = item === null || item === void 0 ? void 0 : item.orgId;
        if (teamId) {
            const members = teamMemberMap[teamId] || [];
            members.push(item);
            teamMemberMap[teamId] = members;
        }
    });
    const res = [];
    teamList.forEach(item => {
        const members = teamMemberMap[item.id];
        const children = [];
        members === null || members === void 0 ? void 0 : members.forEach(member => {
            if (member.model) {
                children.push(transContactModel2ContactItem(member.model));
            }
        });
        res.push(Object.assign(Object.assign({}, item), { children, orgType: 'team' }));
    });
    return res;
};
export const getTeamAndMemberByTeamIds = async (teamIds) => {
    const teamMembers = (await contactApi.doGetOrgContactListByTeamId({
        idList: teamIds,
        needContactModelData: true,
    }));
    const teamMemberMap = {};
    teamMembers.forEach(item => {
        const teamId = item === null || item === void 0 ? void 0 : item.orgId;
        if (teamId) {
            const members = teamMemberMap[teamId] || [];
            members.push(item);
            teamMemberMap[teamId] = members;
        }
    });
    return teamMemberMap;
};
export const getPersonalOrgList = async (account) => {
    const { success, data } = await contactApi.doGetPersonalOrg({ _account: account });
    if (success && data) {
        return data;
    }
    else {
        return [];
    }
};
export const getOrgAndContactById = async (idList) => {
    const contactList = await contactApi.doGetContactByOrgId({ orgId: idList });
    const res = {};
    contactList.forEach(item => {
        if (item.orgs) {
        }
    });
    return res;
};
export const includesContactItem = (data, selectedMap) => {
    return selectedMap.has(getContactItemKey(data));
};
export const getContactItemKey = (data, useContactId, useComposite = false) => {
    if (useComposite) {
        return `${data === null || data === void 0 ? void 0 : data.id}:::${data === null || data === void 0 ? void 0 : data.email}`;
    }
    else if (useContactId) {
        return (data === null || data === void 0 ? void 0 : data.id) || '';
    }
    else {
        return data === null || data === void 0 ? void 0 : data.email;
    }
};
export const getCustomerContactByCustomerIds = async (idList) => {
    const res = await doGetCustomerContactByCustomerIds({ idList });
    return Object.values(res).reduce((pre, cur) => [...pre, ...cur], []);
};
export const getSelectedItemBySelectOrg = async (params) => {
    const { idList, selectedMap, disabledMap, checked = true, selectedList, useContactId, _account, useEdm } = params;
    if (!idList && !selectedList) {
        throw new Error(getIn18Text('BIXUCHUANRUi'));
    }
    let memberList = selectedList;
    if (idList === null || idList === void 0 ? void 0 : idList.length) {
        const contactList = useEdm ? await getCustomerContactByCustomerIds(idList) : await contactApi.doGetContactByOrgId({ orgId: idList, _account });
        memberList = contactList.map(item => transContactModel2ContactItem(item));
    }
    memberList = memberList || [];
    memberList.forEach(item => {
        const key = getContactItemKey(item, useContactId);
        if (!(disabledMap === null || disabledMap === void 0 ? void 0 : disabledMap.get(key))) {
            if (checked) {
                const pre = selectedMap.get(key);
                if (pre) {
                    selectedMap.set(key, getValidEmail(pre, item));
                }
                else {
                    selectedMap.set(key, item);
                }
            }
            else {
                selectedMap.delete(key);
            }
        }
    });
    return {
        contactItem: selectedMap,
        selectContactItem: memberList,
    };
};
export const isOrg = (data) => {
    return data && Boolean('orgType' in data);
};
export const contactUtilError = (msg, e) => {
    console.error(`[contact_util] ${msg}`);
    if (env !== 'prod') {
        throw e;
    }
};
export const getMainAccount = () => { var _a; return ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || ''; };
export const isMainAccount = (_account) => {
    if (_account === undefined) {
        return true;
    }
    return getMainAccount() === _account;
};
const accountEmailSeparator = '&&&';
export const createAccountEmailKey = (email, _account = getMainAccount()) => {
    return `${_account}${accountEmailSeparator}${email === null || email === void 0 ? void 0 : email.toLocaleLowerCase()}`;
};
export const parseAccountEmailKey = (query) => {
    if (query.includes(accountEmailSeparator)) {
        const data = query.split(accountEmailSeparator);
        return {
            account: data[0],
            email: data[1],
        };
    }
    else {
        console.error('parseAccountEmail error', query);
        return null;
    }
};
export const transServerCustomerContactModel2ContactDetail = (list) => {
    return list.map(item => {
        const { contact_id, contact_name, main_contact, email, contact_icon, telephones, whats_app, job, home_page, gender, birthday, remark, pictures, rejected, valid, telephone, address, contact_infos, area, ext_infos, department, social_platform, edm_email_statistic, } = item;
        const ContactDetailItem = {
            contact_id,
            contact_name,
            main_contact,
            email,
            label_list: [],
            contact_icon,
            telephones,
            whats_app,
            social_platform,
            job,
            home_page,
            gender,
            birthday,
            remark,
            pictures: Array.isArray(pictures) ? pictures : [pictures],
            rejected,
            valid,
            telephone,
            address: Array.isArray(address) ? address : [address],
            contact_infos,
            area,
            ext_infos,
            department,
            edm_email_statistic,
        };
        return ContactDetailItem;
    });
};
